export const Target = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00014 13.5714C11.5249 13.5714 13.5716 11.5247 13.5716 9.00002C13.5716 6.47529 11.5249 4.42859 9.00014 4.42859C6.47541 4.42859 4.42871 6.47529 4.42871 9.00002C4.42871 11.5247 6.47541 13.5714 9.00014 13.5714Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99958 11.2857C10.2619 11.2857 11.2853 10.2623 11.2853 8.99995C11.2853 7.73758 10.2619 6.71423 8.99958 6.71423C7.73722 6.71423 6.71387 7.73758 6.71387 8.99995C6.71387 10.2623 7.73722 11.2857 8.99958 11.2857Z"
        fill="currentColor"
      />
      <path d="M15 9H17" stroke="currentColor" strokeLinecap="round" />
      <path d="M1 9H3" stroke="currentColor" strokeLinecap="round" />
      <path d="M9 3L9 1" stroke="currentColor" strokeLinecap="round" />
      <path d="M9 17L9 15" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}
